import React, { ImgHTMLAttributes, SyntheticEvent, useState } from 'react';
import { Loader } from '../Loader/Loader';
import styles from './img.module.css';
import { SvgComponent } from '../../../common/Svg/SvgComponent';

type ImgProps = {
    src?: string;
    alt?: string;
    loading?: ImgHTMLAttributes<unknown>['loading'];
    decoding?: ImgHTMLAttributes<unknown>['decoding'];
    width?: number | string;
    height?: number | string;
    defaultIcon?: string;
    fill?: string;
};
const getNumberSize = (size?: number | string): number | undefined => {
    if (typeof size === 'number') {
        return size;
    }
    if (typeof size === 'string') {
        const clearSize = size.replace('px', '');
        if (!Number.isNaN(Number(clearSize))) {
            return Number(clearSize);
        }
    }
};

const Img = ({ src, width, height, fill, defaultIcon = 'ic_placeholder', alt = '', loading = 'eager', decoding = 'auto' }: ImgProps) => {
    const [loader, setLoader] = useState(true);
    const [error, setError] = useState(false);

    const handleError = (e: SyntheticEvent) => {
        setLoader(false);
        setError(true);
    };
    const handleLoad = () => {
        setLoader(false);
        if (error) {
            setError(false);
        }
    };
    if (error) {
        return <SvgComponent name={defaultIcon} width={getNumberSize(width)} height={getNumberSize(height)} fill={fill} />;
    }

    if (src) {
        return (
            <div className={styles.imgContainer}>
                {loader ? (
                    <div className={styles.loaderContainer}>
                        <Loader width={width} height={height} />
                    </div>
                ) : null}
                <img
                    src={src}
                    alt={alt}
                    loading={loading}
                    decoding={decoding}
                    onLoad={handleLoad}
                    onError={handleError}
                    style={{ visibility: loader ? 'hidden' : 'visible' }}
                />
            </div>
        );
    }
    return null;
};
export { Img };
